import { useCallback, useEffect, useState } from "react";
import { useLazyGetFileByObjectIdAndTypeQuery } from "../../../../../redux/api/FileApi"
import { fileTypes } from "../../../../common/types/types";
import { AuctionResponse } from "../../../types";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { PDFDocumentProxy } from 'react-pdf/node_modules/pdfjs-dist/types/src/display/api';
import { Divider } from "antd";

interface DetailProps {
    item?: AuctionResponse
}

const StatuteDetail = ({ item }: DetailProps) => {
    const [numPages, setNumPages] = useState(0);
    const [seeMore, setSeeMore] = useState(false);
    const [width, setWidth] = useState(0);
    const [trigger, response] = useLazyGetFileByObjectIdAndTypeQuery();

    const divRef = useCallback((node: HTMLDivElement | null) => {
        if (node !== null) {
            setWidth(node.getBoundingClientRect().width);
        }
    }, [])

    useEffect(() => {
        if (item?.statute.statuteId) {
            trigger({
                objectId: item.statute.statuteId,
                objectType: fileTypes.STATUTE,
            })
        }
    }, [trigger, item])

    const onDocumentLoadSuccess = ({ numPages }: PDFDocumentProxy) => {
        setNumPages(numPages);
    }

    return (
        <div>
            {response.data?.length ?
                <div ref={divRef} style={{ maxHeight: seeMore ? '100%' : '545px', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
                    <Document file={process.env.REACT_APP_API_URL + "/files/downloadFile/" + response.data[0].attachmentId} onLoadSuccess={onDocumentLoadSuccess}>
                        {Array.from(new Array(numPages), (el, index) => (
                            <>
                                <Page key={`page_${index + 1}`} pageNumber={index + 1} width={width} />
                                <Divider style={{ borderTop: '1px solid black' }} />
                            </>
                        ))}
                    </Document>
                    {!seeMore && <div className="see-more" onClick={() => setSeeMore(true)}>
                        Xem thêm
                    </div>
                    }
                </div>
                : <></>
            }
        </div>
    )
}

export default StatuteDetail